/**
 * Checks if the object is empty using the fastest method.
 * @param {object} o - The object to check
 */
export function isEmpty(o: object) {
  if (!o || o === null || o === undefined) {
    return true
  }

  if (Array.isArray(o)) {
    return o.length === 0
  }

  return Object.keys(o).length === 0
}
